import { WORKSHOP_COPY, WORKSHOP_CREATE, WORKSHOP_DELETE, WORKSHOP_LIST, WORKSHOP_UPDATE, WORKSHOP_VIEW } from "config/apiPaths"
import { baseApi } from 'utils/axios/baseApi';

export const workshop = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // create note
    getClientDetails: builder.query({
      query: ({ clientType, clientId }) => ({
        method: "GET",
        url: `/client/${clientType}/detail/${clientId}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
    }),
  }),
})

export const {
    useGetClientDetailsQuery
} = workshop;